<template>
  <div class="profile">
    <div class="top fadein">
      <h1>Profiel</h1>
      <button class="logout" @click="logout">Uitloggen</button>
    </div>
    <div class="info fadein" v-if="!loading">
      <div class="field email">
        <label for="email">E-mail:</label>
        <input type="text" v-model="user.email">
      </div>

      <div class="field firstname">
        <label for="firstname">Voornaam:</label>
        <input type="text" v-model="user.firstname">
      </div>

      <div class="field lastname">
        <label for="lastname">Achternaam:</label>
        <input type="text" v-model="user.lastname">
      </div>

      <div class="field colour">
        <label for="colour">Kleur:</label>
        <input type="color" v-model="user.colour">
      </div>

      <div class="change-password">
        <button @click="changingPassword = true">Wachtwoord veranderen</button>
      </div>

      <div class="save">
        <button @click="save">Opslaan</button>
      </div>

      <change-password v-if="changingPassword" @close="changingPassword = false"></change-password>
    </div>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode'

import ChangePassword from './ChangePassword'

export default {
  name: 'Profile',
  components: {
    'change-password': ChangePassword
  },
  data() {
    return {
      userId: parseInt(jwt_decode(localStorage.getItem('token')).id),
      user: {},
      loading: false,
      changingPassword: false
    }
  },
  methods: {
    logout() {
      this.global.baseView.logout();
    },
    save() {
      const token = localStorage.getItem('token');

      this.axios.put(this.config.api + '/users', {
        id: this.userId,
        email: this.user.email,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        colour: this.user.colour
      }, {
        headers: {
          authorization: token
        }
      })
        .then(() => {
          alert('Aanpassingen zijn opgeslagen');
        })
        .catch((error) => {
          alert(error.message)
        })
    },
    getUser() {
      const token = localStorage.getItem('token');
      this.loading = true;
      this.global.GetBaseView().startLoad();

      this.axios.get(this.config.api + '/users/' + this.userId, {
        headers: {
          authorization: token
        }
      })
        .then(result => {
          this.user = result.data;
          this.loading = false;
          this.global.GetBaseView().endLoad();
        })
        .catch(() => {
          this.global.GetBaseView().logout();
          this.global.GetBaseView().endLoad();
          this.loading = false;
        })}
  },
  created() {
    this.getUser();
  },
}
</script>

<style scoped>

.profile {
  padding: 10px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.options > a {
  margin-left: 10px
}

.field {
  width: 100%;
  padding: 10px 0;

  display: flex;
  justify-content: space-between;
}

.save {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

input {
  width: 60%;
}

.logout {
  border-color: rgb(226, 72, 72);
  color: white;
  background-color: rgb(226, 72, 72);
}

</style>



// WEBPACK FOOTER //
// src/components/Profile.vue